export const MarketingIcon = ({ useOriginalColor }) => (
  <svg width="20" height="22" viewBox="0 0 20 22" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M7.16321 15.1968C8.09728 14.8713 9.11837 15.3646 9.44388 16.2987L10.3285 18.8373C10.6541 19.7714 10.1607 20.7925 9.22665 21.118C8.29258 21.4435 7.27149 20.9502 6.94599 20.0161L6.06131 17.4775C5.73581 16.5434 6.22914 15.5223 7.16321 15.1968Z"
      fill={useOriginalColor ? "url(#paint0_linear_1645:71131)" : "currentColor"}
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M15.2721 0.0904937C15.8444 0.279622 16.2831 0.743867 16.4396 1.32586L19.9385 14.3345C20.078 14.853 19.9775 15.4067 19.6647 15.8431C19.3518 16.2796 18.8598 16.5526 18.3239 16.5871L2.98268 17.5739C2.14187 17.628 1.37704 17.0888 1.14558 16.2786L0.0689978 12.5106C-0.130255 11.8132 0.110757 11.0645 0.67942 10.6143L13.5984 0.386802C14.0709 0.0127169 14.6999 -0.0986342 15.2721 0.0904937ZM3.8425 12.6789L4.19326 13.9066L15.9113 13.1528L13.6875 4.88492L3.8425 12.6789Z"
      fill={useOriginalColor ? "url(#paint1_linear_1645:71131)" : "currentColor"}
    />
    <defs>
      <linearGradient
        id="paint0_linear_1645:71131"
        x1="6.50365"
        y1="18.7468"
        x2="5.76194"
        y2="19.0053"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#CA0C6B" />
        <stop offset="1" stop-color="#FF158A" />
      </linearGradient>
      <linearGradient
        id="paint1_linear_1645:71131"
        x1="8.58159"
        y1="17.4646"
        x2="15.9255"
        y2="10.6648"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#FF158A" />
        <stop offset="1" stop-color="#FF158A" />
      </linearGradient>
    </defs>
  </svg>
);
